var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChainId, PUBLIC_RPCS } from '@shared/utils/config/networks';
import { Connection } from '@solana/web3.js';
import { ethers } from 'ethers';
export default function awaitTransactionConfirmation(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var controller, networks, TIMEOUT_MS, timeoutId, results, solanaTxnError, evmTxnError, allSolana, e_1;
        var _this = this;
        var hashPayload = _b.hashPayload;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    controller = new AbortController();
                    networks = hashPayload === null || hashPayload === void 0 ? void 0 : hashPayload.map(function (x) { return x === null || x === void 0 ? void 0 : x.network; });
                    TIMEOUT_MS = (networks === null || networks === void 0 ? void 0 : networks.includes(ChainId.ETHEREUM)) ? 45000 : 20000;
                    timeoutId = setTimeout(function () { return controller.abort(); }, TIMEOUT_MS);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Promise.all(hashPayload.map(function (hash) { return __awaiter(_this, void 0, void 0, function () {
                            var abortSignal, connection, rpc;
                            return __generator(this, function (_a) {
                                abortSignal = controller.signal;
                                if (hash.network === ChainId.SOLANA || hash.network === ChainId.SOLANA_DLN) {
                                    connection = new Connection('https://mainnet.helius-rpc.com/?api-key=8bab07d6-d614-478e-ba36-c2e07ea6d720', 'confirmed');
                                    return [2 /*return*/, confirmSolanaTransactionWithTimeout(connection, hash.hash, abortSignal)];
                                }
                                else {
                                    rpc = PUBLIC_RPCS[hash.network];
                                    return [2 /*return*/, confirmEVMTransactionWithTimeout(rpc, hash.hash, abortSignal)];
                                }
                                return [2 /*return*/];
                            });
                        }); }))];
                case 2:
                    results = _c.sent();
                    solanaTxnError = results.some(function (x) {
                        return x === null || x === void 0 ? void 0 : x.error;
                    });
                    evmTxnError = results.some(function (x) {
                        var _a;
                        return ((_a = x === null || x === void 0 ? void 0 : x.receipt) === null || _a === void 0 ? void 0 : _a.status) == 0;
                    });
                    console.log('Executing order in await finalization', results, solanaTxnError, evmTxnError);
                    if (solanaTxnError || evmTxnError) {
                        return [2 /*return*/, {
                                error: 'Transactions did not finalize! Please try again.',
                            }];
                    }
                    allSolana = hashPayload.every(function (hash) { return hash.network === ChainId.SOLANA || hash.network === ChainId.SOLANA_DLN; });
                    return [2 /*return*/, allSolana
                            ? results
                            : results];
                case 3:
                    e_1 = _c.sent();
                    if (e_1.name === 'AbortError') {
                        return [2 /*return*/, {
                                error: 'Transactions did not finalize. Please try again.',
                            }];
                    }
                    console.error('Error in checkTransactionConfirmation', e_1);
                    return [2 /*return*/, {
                            error: e_1.message,
                        }];
                case 4:
                    clearTimeout(timeoutId);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function confirmSolanaTransactionWithTimeout(connection, signature, abortSignal) {
    return __awaiter(this, void 0, Promise, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var checkSignature = function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, error_1;
                        var _a, _b, _c, _d;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    _e.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, connection.getSignatureStatus(signature)];
                                case 1:
                                    status = _e.sent();
                                    console.log('Executing order in confirmSolanaTransactionWithTimeout', status, signature);
                                    if ((_a = status === null || status === void 0 ? void 0 : status.value) === null || _a === void 0 ? void 0 : _a.err) {
                                        // Transaction landed but had an error
                                        resolve({
                                            status: status,
                                            signature: signature,
                                            error: JSON.stringify(status.value.err),
                                        });
                                    }
                                    if (((_b = status === null || status === void 0 ? void 0 : status.value) === null || _b === void 0 ? void 0 : _b.confirmationStatus) === 'confirmed' ||
                                        ((_c = status === null || status === void 0 ? void 0 : status.value) === null || _c === void 0 ? void 0 : _c.confirmationStatus) === 'finalized' ||
                                        ((_d = status === null || status === void 0 ? void 0 : status.value) === null || _d === void 0 ? void 0 : _d.confirmationStatus) === 'processed') {
                                        resolve({ status: status, signature: signature });
                                    }
                                    else {
                                        setTimeout(checkSignature, 500);
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _e.sent();
                                    reject(error_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    abortSignal.addEventListener('abort', function () {
                        reject(new Error('Transaction confirmation timed out'));
                    }, { once: true });
                    checkSignature();
                })];
        });
    });
}
function confirmEVMTransactionWithTimeout(rpcUrl, txHash, abortSignal) {
    return __awaiter(this, void 0, Promise, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var provider = new ethers.providers.JsonRpcProvider(rpcUrl);
                    var checkTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
                        var tx, receipt, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    return [4 /*yield*/, provider.getTransaction(txHash)];
                                case 1:
                                    tx = _a.sent();
                                    if (!tx) {
                                        setTimeout(checkTransaction, 500);
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, tx.wait(1)];
                                case 2:
                                    receipt = _a.sent();
                                    if (receipt.status === 1) {
                                        resolve({ receipt: receipt, txHash: txHash });
                                    }
                                    else {
                                        reject(new Error('Transaction failed'));
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    reject(error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); };
                    abortSignal.addEventListener('abort', function () {
                        reject(new Error('Transaction confirmation timed out'));
                    }, { once: true });
                    checkTransaction();
                })];
        });
    });
}
